import { captureException } from '@sentry/react'
import { useState } from 'react'

import type { ReactElement } from 'react'

import ManageGroupModal from '../../ManageGroupModal'

import Button from '~/components/Buttons/Button'
import Label from '~/components/Label'
import { displayToast } from '~/utils/toast'

import './styles.scss'

interface Props {
  description: string
  id: string
  name: string
}

const GroupDetailsGeneralInformation = ({ description, id, name }: Props): ReactElement => {
  /** Local state */

  const [isModalOpen, setIsModalOpen] = useState(false)

  /** Handlers */

  const handleModalState = (value: boolean) => () => setIsModalOpen(value)

  const handleSuccess = () => {
    setIsModalOpen(false)
    displayToast('Group successfully updated', 'success')
  }

  const handleFailure = (error: unknown) => {
    captureException(error)
    displayToast('Group could not be updated', 'error')
    setIsModalOpen(false)
  }

  /** Render */

  return (
    <div className="group-details-general-information">
      <div className="input-container">
        <Label className="label" label="Name" />
        <span className="value-container" title={name}>
          {name}
        </span>
      </div>
      <div className="input-container">
        <Label className="label" label="Description" />
        <span className="value-container" title={description}>
          {description}
        </span>
      </div>
      <div className="actions-container">
        <Button onClick={handleModalState(true)} outlined size="small">
          Edit
        </Button>
      </div>
      <ManageGroupModal
        description={description}
        id={id}
        isOpen={isModalOpen}
        name={name}
        onClose={handleModalState(false)}
        onFailure={handleFailure}
        onSuccess={handleSuccess}
      />
    </div>
  )
}

export default GroupDetailsGeneralInformation
